export default __webpack_public_path__ + "locales/lv/ChangeUserTypeDialog.json?hash=6b181d7b62803b8858b4cf71c87707f7";